import React from "react";
import Statistics from "../core/Statistics";
import {defaultSeason} from "../utils/time";

const DivisionStatistics = ( {divisionID, divisionName, divisionTeams} ) => {
 
  return (
    <Statistics
      mode={'division'}
      id={divisionID}
      divisionName={divisionName}
      seasons={[defaultSeason()]}
      teams={divisionTeams}
    />
  );
}

export default DivisionStatistics;